export default [
  config => {
    config.headers.Brand = 'sdx_web'
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  },
]
